import React from "react"
import sidebar from "./sidebar.json"
import { Link } from "react-router-dom"
import Dropdown from "react-bootstrap/Dropdown"
import { handleLogout } from "../../utils/utils"

const Header = ({ isSidebarOpen, setIsSidebarOpen }: any) => {
  const toggleSidebar = () => setIsSidebarOpen((prev: any) => !prev)
  const [search, setSearch] = React.useState("")
  const [searchData, setSearchData] = React.useState<any[]>([])

  const handleChangeSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearch(event.target.value)
    const filteredData = Object.entries(sidebar).filter(([key, value]) =>
      key.toLowerCase().includes(event.target.value.toLowerCase()),
    )
    if (event.target.value) {
      setSearchData(filteredData.map(([key, value]) => ({ name: key, path: value })))
    } else {
      setSearchData([])
    }
  }
  return (
    <section className='searchBar-section '>
      <div className='container'>
        <div className='row'>
          <div className='col-4 col-sm-6 col-lg-3 menu-btn-col'>
            <div className='menu-btn-main-section'>
              <div className='menu-profile-section'>
                <button className='menu-btn' onClick={toggleSidebar}>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    fill='none'
                    viewBox='0 0 24 24'
                    strokeWidth={1.5}
                    stroke='#353a44'
                    className='icon'
                    width="24"
                    height="24"
                  >
                    <path
                      strokeLinecap='round'
                      strokeLinejoin='round'
                      d='M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5'
                    />
                  </svg>
                </button>
                <h2>Admin Panel</h2>
              </div>
            </div>
          </div>
          {/* <div></div> */}
          <div className='col-8 col-sm-6 col-lg-9 col-xl-12'>
            <div className='header-seaction-icons'>
              <div className='searchBar-main-section relative'>
                <div className='search-bar-section'>
                  <input
                    type='text'
                    placeholder='Search'
                    className=''
                    onChange={(event: any) => handleChangeSearch(event)}
                    value={search}
                  />
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    fill='none'
                    viewBox='0 0 24 24'
                    strokeWidth={1.5}
                    stroke='currentColor'
                    className='icon'
                  >
                    <path
                      strokeLinecap='round'
                      strokeLinejoin='round'
                      d='m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z'
                    />
                  </svg>
                </div>
                {searchData.length > 0 && (
                  <div className='search-options'>
                    <div className='search-results '>
                      <ul className='search-results-list'>
                        {searchData.map((item, index) => (
                          <li className='search-results-item'>
                            <Link
                              key={index}
                              to={item.path}
                              className='search-result-link'
                              onClick={() => {
                                setSearch("")
                                setSearchData([]) // Clear search results on click");
                              }}
                            >
                              {item.name}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                )}
              </div>
              <div className='header-icons-seaction'>
                <Dropdown align='end' className='comman-dropdown'>
                  <Dropdown.Toggle
                    variant='white'
                    id='dropdown-profile'
                    className='header-icon-btn comman-dropdown-button'
                  >
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='25'
                      height='25'
                      fill='currentColor'
                      className='bi bi-person'
                      viewBox='0 0 16 16'
                    >
                      <path d='M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6m2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0m4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4m-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10s-3.516.68-4.168 1.332c-.678.678-.83 1.418-.832 1.664z' />
                    </svg>
                  </Dropdown.Toggle>

                  <Dropdown.Menu className='comman-dropdown-menu'>
                    <Dropdown.Item as={Link} to='/changePassword' className='comman-dropdown-item'>
                      Change Password
                    </Dropdown.Item>
                    <Dropdown.Item onClick={handleLogout} className='comman-dropdown-item'>
                      Logout
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </div>
          </div>
          <div></div>
        </div>
      </div>
    </section>
  )
}

export default Header
